import React from 'react';
import { Box } from '@mui/material';
import TopStepAccountPage, { type AccountPageProps } from './TopStepAccountPage';
import ProfileCDecisionLog from '../components/ProfileCDecisionLog';

const TOPSTEP_EXPRESS_FUNDED_ACCOUNT_ID = 24612688;
const TOPSTEP_EXPRESS_FUNDED_MARKERS = ['573439-84199727', '84199727', 'EXPRESS-V2-CT-DLL-573439'];

const matchTopStepExpressFundedAccount: AccountPageProps['accountMatcher'] = (accounts) => {
  const exact = accounts.find((account) => account.accountId === TOPSTEP_EXPRESS_FUNDED_ACCOUNT_ID);
  if (exact) return exact;

  return accounts.find((account) => {
    const accountName = account.accountName || '';
    return TOPSTEP_EXPRESS_FUNDED_MARKERS.some((marker) => accountName.includes(marker));
  });
};

const TopStepExpressFundedPage: React.FC = () => (
  <Box>
    <TopStepAccountPage
      accountLabel="TopStep Express Funded (Isaiah)"
      accountMatcher={matchTopStepExpressFundedAccount}
      challengeParams={{ target: 750, hardMax: 1000, internalStop: 1000, dailyCap: 1000, accountSize: 50000 }}
      chipLabel="EXPRESS FUNDED"
      chipColor="#4CAF50"
    />
    <ProfileCDecisionLog
      accountId={TOPSTEP_EXPRESS_FUNDED_ACCOUNT_ID}
      label="EXPRESS FUNDED · 24612688"
    />
  </Box>
);

export default TopStepExpressFundedPage;
